import { render, staticRenderFns } from "./crudRetirementSettings.vue?vue&type=template&id=0a1ffaa4&scoped=true"
import script from "./crudRetirementSettings.vue?vue&type=script&lang=js"
export * from "./crudRetirementSettings.vue?vue&type=script&lang=js"
import style0 from "./crudRetirementSettings.vue?vue&type=style&index=0&id=0a1ffaa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ffaa4",
  null
  
)

export default component.exports